module.exports = __webpack_public_path__ + "img/GENESIS.aefbf930.webp";